@if (info | async; as userInfo) {
  @if (userInfo?.recertification?.status === 'EXPIRED') {
    <div>
      <div class="icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          fill="none"
          >
          <path
            fill="#E4002B"
            d="M7 .344A6.642 6.642 0 0 0 .344 7 6.642 6.642 0 0 0 7 13.656 6.642 6.642 0 0 0 13.656 7 6.642 6.642 0 0 0 7 .344Zm2.875 9.531c-.281.25-.688.25-.938 0L7 7.937 5.062 9.876c-.25.25-.656.25-.937 0-.25-.281-.25-.688 0-.938L6.063 7 4.125 5.062c-.25-.25-.25-.656 0-.937.281-.25.688-.25.938 0L7 6.063l1.938-1.938c.25-.25.656-.25.937 0 .25.281.25.688 0 .938L7.937 7l1.938 1.938c.25.25.25.656 0 .937Z"
            />
        </svg>
      </div>
      <div class="content">
        <span
          >Certificação expirada dia
          {{ userInfo.recertification.limitDate | date : "dd/MM/yyyy" }}</span
          >
        </div>
      </div>
    }
    @if (userInfo?.recertification?.status === 'PENDING' || userInfo?.recertification?.status === 'ATTESTED'
      ) {
      <div
        >
        <div class="icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            fill="none"
            >
            <path
              fill="#009F4D"
              d="M7 .344A6.642 6.642 0 0 0 .344 7 6.642 6.642 0 0 0 7 13.656 6.642 6.642 0 0 0 13.656 7 6.642 6.642 0 0 0 7 .344ZM5.187 9.875 2.813 7.469a.626.626 0 0 1 0-.938c.25-.25.657-.25.938 0l1.906 1.907 4.594-4.563a.626.626 0 0 1 .938 0c.28.25.28.656 0 .938L6.125 9.875c-.25.25-.656.25-.938 0Z"
              />
          </svg>
        </div>
        <div class="content">
          <span
            >Certificação válida até
            {{ userInfo.recertification.limitDate | date : "dd/MM/yyyy" }}</span
            >
          </div>
        </div>
      }
    }
